import { deserialize, inheritSerialization } from 'cerialize'
import { ShortDataModel, ReceivingFileModel } from 'Models'
import { FieldNames } from 'Constants/FieldNames'
import {
	AWAITING_DEFAULT_STATUS,
	TaxReasonType,
	GuaranteeTextType,
	FixedCommissionType,
	BgRequestType,
	BenefInfoType,
	LegalAuthorityType,
	ReputationType,
	StatusGartext,
	ActiveLead,
	SignedContractFlagValues,
	BgFlagpowerattornay,
	StatusBg,
	BankGuarantee,
	License,
	BgPublicationModel,
} from 'Pages/ibro'

@inheritSerialization(BankGuarantee)
export class BankGuaranteeFull extends BankGuarantee {
	@deserialize public locked_fields!: FieldNames[]
	@deserialize public required_fields!: FieldNames[]
	@deserialize public comments!: string // ошибка от АСТ
	@deserialize public fields!: FieldNames[]
	@deserialize public 'active_lead_present?': boolean // согласие ПД
	@deserialize public requestdate!: string // Дата окончания подачи заявок
	@deserialize public commission!: number // стоимость гарантии для клиента
	@deserialize public fee!: number // размер комиссии
	@deserialize public agentminfee!: string // минимальный размер комиссии
	@deserialize public amount_base!: number
	@deserialize public increased_amount!: boolean
	@deserialize public phone!: string
	@deserialize public email!: string
	@deserialize public enddate!: string
	@deserialize public sendaddress: any // адрес доставки
	@deserialize public phonefordelivery!: string // телефон для доставки
	@deserialize public personfordelivery!: string // контактное лицо для доставки
	@deserialize public agentinn!: string
	@deserialize public fillingdate!: string
	@deserialize public agentemail!: string
	@deserialize public taxationsystem!: string // система н/о
	@deserialize public noncurrentassets!: number // внеобортные активы
	@deserialize public currentassets!: number // обортные активы
	@deserialize public capitalreserves!: number // капиталы и резервы
	@deserialize public currentliab!: number // краткосрочные обяз-ва
	@deserialize public longtermliab!: number // долгосрочные обяз-ва
	@deserialize public doh_bud_per!: number // доходы будущих периодов
	@deserialize public reven!: number // выручка
	@deserialize public netprofit!: number // чистая прибыль
	@deserialize public curentaccount!: string // расчетный счет
	@deserialize public bik!: string
	@deserialize public bankname!: string
	@deserialize public correspaccount!: string // корреспондентский счет
	@deserialize public agreementfatca!: string // уточнить тип
	@deserialize public benef!: BenefInfoType
	@deserialize public contractors!: string // уточнить тип
	@deserialize public facts!: string // Сведения о негативных фактах
	@deserialize public fatcaflag!: boolean
	@deserialize public flagsovet!: boolean
	@deserialize public ispravlenietext!: string // инф-ия о членах Совета директоров
	@deserialize public isagentbenef!: boolean
	@deserialize public iscorporate!: boolean // уточнить тип
	@deserialize public nameprepost!: string // занимаемая должность (если typelegalauthority)
	@deserialize public orgaddress!: string // адрес работодателя (если typelegalauthority)
	@deserialize public orgrezidflag!: boolean
	@deserialize public reputation!: ReputationType
	@deserialize public personrezidflag!: boolean
	@deserialize public typelegalauthority!: LegalAuthorityType // руководитель является
	@deserialize public taxcountry1!: string
	@deserialize public taxin1!: string
	@deserialize public taxreason1!: TaxReasonType
	@deserialize public taxreasontext1!: string
	@deserialize public taxcountry2!: string
	@deserialize public taxin2!: string
	@deserialize public taxreason2!: TaxReasonType
	@deserialize public taxreasontext2!: string
	@deserialize public customerregnum!: string
	@deserialize public customername!: string
	@deserialize public customeraddress!: string
	@deserialize public customerinn!: string
	@deserialize public customerkpp!: string
	@deserialize public customerogrn!: string
	@deserialize public actingunder?: string // действует на основании
	@deserialize public authaddress?: any // адрес руководителя
	@deserialize public authinn?: string // ИНН руководителя
	@deserialize public authpersoncitizenship?: string // гражданство руководителя
	@deserialize public authpersondate?: string // ДР руководителя
	@deserialize public authpersonplace?: string // место рождения заявителя
	@deserialize public authposition?: string // должность руководителя
	@deserialize public authpassport!: string // Наименование паспорта
	@deserialize public authpassportser?: string // серия паспорта рук-ля орг-ии
	@deserialize public authpassportnum?: string // номер паспорта рук-ля орг-ии
	@deserialize public authpassportwhogive?: string // кем выдан паспорт рук-ля орг-ии
	@deserialize public authpassportdategive?: string // дата выдачи паспорта рук-ля орг-ии
	@deserialize public authpassportkod?: string // код под-ия паспорта рук-ля орг-ии
	@deserialize public firstaccount!: string // 1ый р/с в СберБанке
	@deserialize public secondaccount!: string // 2ый р/с в СберБанке
	@deserialize public thirdaccount!: string // 3ый р/с в СберБанке
	@deserialize public addressfact: any
	@deserialize public addressjur: any
	@deserialize public inn!: string
	@deserialize public kpp!: string
	@deserialize public fullname!: string
	@deserialize public ogrn!: string
	@deserialize public ogrnip!: string
	@deserialize public okato!: string
	@deserialize public okpo!: string
	@deserialize public oktmo!: string
	@deserialize public okvedanover!: string // основной оквэд
	@deserialize public registrationaddress!: number // место гос-ой регистрации компании
	@deserialize public registrationdate!: string // дата регистрации компании
	@deserialize public registrationtaxdate!: string // дата постановки на учет
	@deserialize public fio!: string // ФИО руководителя орг-ии
	@deserialize public flaglicense!: boolean
	@deserialize public licenses!: License[]
	@deserialize public licenseviewnumber!: string // номер лицензии
	@deserialize public licenseactivity!: string // вид деятельности
	@deserialize public licensedate!: string // дата выдачи лицензии
	@deserialize public licenseterm!: string // срок действия лицензии
	@deserialize public licensewhogive!: string // кем выдана лицензия
	@deserialize public purchamount!: number // начальная (максимальная) цена контракта
	@deserialize public placeraddress!: string // адрес орг-ии, осуществляющей размещение
	@deserialize public placerinn!: string // ИНН орг-ии, осуществляющей размещение
	@deserialize public placername!: string // наименовании орг-ии, осуществляющей размещение
	@deserialize public placingwayname!: string // подспособ определения поставщика (подрядчика, исполнителя)
	@deserialize public purchcode!: string // код закупки
	@deserialize public purchname!: string // объект закупки
	@deserialize public lotnumber!: number // номер лота (в многолотовой закупке)
	@deserialize public lotname!: string // имя лота (в многолотовой закупке)
	@deserialize public beneficiaries!: string[] // уточнить тип
	@deserialize public doc_types!: FieldNames[] // список обязательных документов
	@deserialize public newguaranteeblank?: ReceivingFileModel // нестандартный бланк гарантии
	@deserialize public financialstatement?: ReceivingFileModel // финансовая отчётность за последний год
	@deserialize public bigdealprotocol?: ReceivingFileModel // протокол одобрения крупной сделки или сделки
	@deserialize public ipscan?: ReceivingFileModel // копия паспорта индивидуального предпринимателя
	@deserialize public gendirscan?: ReceivingFileModel // копия паспорта Генерального Директора
	@deserialize public ustav?: ReceivingFileModel // устав
	@deserialize public protocolgendirscan?: ReceivingFileModel // протокол назначения генерального директора
	// eslint-disable-next-line max-len
	@deserialize public bigdealagreement?: ReceivingFileModel // письмо об отсутствии необходимости одобрения крупной сделки
	@deserialize public debtletter?: ReceivingFileModel // письмо об отсутствии просроченной задолженности
	@deserialize public anketafsc?: ReceivingFileModel // анкета финансового состояния клиента
	@deserialize public egrul?: ReceivingFileModel // Выписка ЕГРЮЛ ЕГРИП
	@deserialize public otherdocs?: ReceivingFileModel // Прочие документы
	@deserialize public customerapplicationguarantee!: number
	@deserialize public customercontractguarantee!: number
	@deserialize public customerwarrantyguarantee!: number
	@deserialize public confirmation_created_at?: string
	@deserialize public isstateno?: boolean
	@deserialize public delivery?: number // стоимость доставки
	@deserialize public guaranteetemplate?: ReceivingFileModel
	@deserialize public guaranteetemplatepp?: ReceivingFileModel
	@deserialize public factaddresskladr!: string
	@deserialize public factflatnumber!: string
	@deserialize public facthousenumber!: string
	@deserialize public factindex!: string
	@deserialize public juraddresskladr!: string
	@deserialize public jurindex!: string
	@deserialize public jurhousenumber!: string
	@deserialize public jurflatnumber!: string
	@deserialize public authaddresskladr!: string
	@deserialize public authindex!: string
	@deserialize public authhousenumber!: string
	@deserialize public authflatnumber!: string
	@deserialize public arbitrage?: string
	@deserialize public isbigdeal?: boolean
	@deserialize public guarantee_text_type!: GuaranteeTextType
	@deserialize public confirmed!: boolean
	@deserialize public statusgartext?: StatusGartext
	@deserialize public currentassetslast!: number // обортные активы предыдущего года
	@deserialize public capitalreserveslast!: number // капиталы и резервы предыдущего года
	@deserialize public currentliablast!: number // краткосрочные обяз-ва предыдущего года
	@deserialize public netprofitlast!: number // чистая прибыль предыдущего года
	@deserialize public activexmlksb!: boolean // чистая прибыль предыдущего года
	@deserialize public locked_by_service_request!: boolean // флаг выполнения запроса
	@deserialize public locking_service_request!: BgRequestType | typeof AWAITING_DEFAULT_STATUS
	@deserialize public fixedcommission!: FixedCommissionType
	@deserialize public active_leads!: ActiveLead[]
	@deserialize public agreewithoutikz!: 'on' | null
	@deserialize public order_number!: string
	@deserialize public check_status_amount!: string
	@deserialize public customeremail!: string
	@deserialize public customerphone!: string
	@deserialize public customeroktmo!: string
	@deserialize public reject_description!: string
	@deserialize public purchurlischeck!: boolean
	@deserialize public supportdoc!: ReceivingFileModel
	@deserialize public request_options!: {
		guarantee_text_types: ShortDataModel<GuaranteeTextType>[]
	}
	@deserialize public release_blocked!: boolean
	@deserialize public upload_files_messages!: Record<string, string>[]
	@deserialize public contractsubject!: string
	@deserialize public contractdate!: string
	@deserialize public contractnumber!: string
	@deserialize public external_url!: string
	@deserialize public sign_trust_document?: ReceivingFileModel | null
	@deserialize public signedcontractflag!: SignedContractFlagValues
	@deserialize public flagpowerofattorney!: BgFlagpowerattornay
	@deserialize public numberpowerofattorney!: string
	@deserialize public datepowerofattorney!: string
	@deserialize public fio_director!: string
	@deserialize public authinn_director!: string
	@deserialize public authaddress_director?: any
	@deserialize public authpassport_director!: string
	@deserialize public authpassportser_director!: string
	@deserialize public authpassportnum_director!: string
	@deserialize public authpassportwhogive_director!: string
	@deserialize public authpassportdategive_director!: string
	@deserialize public authpassportkod_director!: string
	@deserialize public authpersoncitizenship_director!: string
	@deserialize public authpersondate_director!: string
	@deserialize public authpersonplace_director!: string
	@deserialize public authposition_director!: string
	@deserialize public powerofattorneyjur!: ReceivingFileModel
	@deserialize public agreement_director_sign!: ReceivingFileModel
	@deserialize public status!: StatusBg
	@deserialize public purchcustomername!: string | null
	@deserialize public purchcustomerinn!: string | null
	@deserialize public purchcustomerkpp!: string | null
	@deserialize public publicationdatetime!: string | null
	@deserialize public hidden_fields!: FieldNames[]
	@deserialize public publication!: BgPublicationModel | null
	@deserialize public new_lead_requested!: boolean
	@deserialize public g_publish: 0 | 1
	@deserialize public notcheckstartdate: boolean

	public get created_date(): string | undefined {
		return this.created_at ? this.created_at.slice(0, 10) : undefined
	}
}

export type BankGuaranteeSaveModel = Partial<Omit<BankGuaranteeFull, 'id'>> &
	Pick<BankGuaranteeFull, 'id'>
